import {NgModule} from '@angular/core';
import {MatProgressBarModule as MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSlideToggleModule as MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSliderModule as MatSliderModule } from '@angular/material/slider';


@NgModule({
  exports: [
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatSliderModule,
  ]
})
export class MaterialModel {}
